export const mapToColumnField = (data) => {
  const fieldMap = {
    company: "companyId",
    team: "teamId",
    department: "departmentId",
    position: "postId",
  };

  // If it's a string (single column key), return mapped value
  if (typeof data === 'string') {
    return fieldMap[data] || data;
  }

  if (typeof data === 'object' && data !== null) {
    const mappedData = {};
    
    for (const [key, value] of Object.entries(data)) {
      const mappedKey = fieldMap[key] || key;
      mappedData[mappedKey] = value;
    }
    
    return mappedData;
  }

  return data;
};